<div class="modal fade" id="exampleModalToggleReport" aria-hidden="true" aria-labelledby="exampleModalToggleReportLabel"
	tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalToggleReportLabel">Horoscope Report Order Details</h1>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="modal" aria-label="Close"><img
						src="/assets/images/new-cross.svg" alt=""></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-lg-12 ">
						<div class="card ">
							<div class="row justify-content-center">
								<div class="row">
									<div class="col-lg-12  ">
										<div class="row">
											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Name :
													</strong></span><span>{{reportOrderData?.customerName}} </span>
											</div>

											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Gender : </strong></span><span>{{reportOrderData?.gender}}
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Birth Date :
													</strong></span><span>{{reportOrderData?.birthDate}} </span>
											</div>

											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Birth Place :
													</strong></span><span>{{reportOrderData?.birthPlace}} </span>
											</div>
										</div>

										<div class="row">
											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Report Type :
													</strong></span><span>{{reportOrderData?.reportType}} </span>
											</div>

											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Order Amount :
													</strong></span><span>{{reportOrderData?.orderPrice}} </span>
											</div>
										</div>

										<div class="row">
											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>Answer
														Status :
													</strong></span><span>{{reportOrderData?.answerStatus}}</span>
											</div>

											<div class="col-lg-6 col-md-12 col-sm-12">
												<span><strong>My
														Query : </strong></span><span>{{reportOrderData?.comments}}
												</span>
											</div>
										</div>

										<div class="row">
											<div class="col-lg-12 col-md-12 col-sm-12">
												<span class="ftW"><strong>Advisor Name :</strong> 
												</span><span>{{reportOrderData?.astrologerName}} </span>
											</div>

										</div>

										<div class="row" *ngIf="reportOrderData?.astrologerAnswer">
											<div class="col-lg-12 col-md-12 col-sm-12 mt-3">
												<span class="ftW"><strong>Advisor Answer</strong> : </span>
												<div class="card analysis mt-3 mb-5">{{reportOrderData?.astrologerAnswer}} </div>
											</div>
										</div>


									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="modal-footer justify-content-start mb-5">
				<button class="btn-down">Download PDF <img src="/assets/images/download.svg" alt=""></button>
			</div> -->
		</div>
	</div>
</div>